import StoreUtil from '@/store/StoreUtil'

export default {
  FETCH_COUNTRIES_LIST: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'fetchCountriesList'
  ),
  FETCH_REGIONS_LIST: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'fetchRegionsList'
  ),
  SET_CLIENT_COUNTRY: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'setClientCountry'
  ),
}
